import { render, staticRenderFns } from "./Session.vue?vue&type=template&id=6a50c976&scoped=true&"
import script from "./Session.vue?vue&type=script&lang=js&"
export * from "./Session.vue?vue&type=script&lang=js&"
import style0 from "./Session.vue?vue&type=style&index=0&id=6a50c976&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a50c976",
  null
  
)

export default component.exports